import React from 'react'
import { useQueryClient } from 'react-query'
import { toast } from 'sonner'
import { taskService } from '@/services/taskService'
import { useDebouncedSave } from '@/lib/useDebouncedSave'
import RichTextEditor from './RichTextEditor'

// "Definition of done" kept separate from the description — usually a checklist. AI agents
// read it as its own section and can tick it off when the work is done.
const AcceptanceCriteria = ({ task, projectId, mentionUsers = [] }) => {
  const queryClient = useQueryClient()

  const save = useDebouncedSave(async (html) => {
    try {
      await taskService.updateTask(projectId, task.id, { acceptance_criteria: html })
      queryClient.invalidateQueries(['projects', String(projectId), 'tasks', String(task.id)])
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to save acceptance criteria')
    }
  })

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium">Acceptance criteria</h3>
      <RichTextEditor
        key={`ac-${task.id}`}
        content={task.acceptance_criteria || ''}
        onChange={save}
        placeholder="When is this done? Tip: use a checklist (☑ in the toolbar)"
        minHeight={60}
        mentionUsers={mentionUsers}
      />
    </div>
  )
}

export default AcceptanceCriteria
